import { r } from "./register-2LfEPho3.js";
import { D as i } from "./register-2LfEPho3.js";
r();
export {
  i as Dialog
};
